
export const common = {
  date: "Date",
  empty: "Empty",

  open: "Open",
  close: "Close",
}
